<template>
  <v-form
    id="nokDetails"
    v-model="valid"
    lazy-validation
  >
    <v-row>
      <v-col
        cols="12"
        class="d-flex align-center"
      >
        <h2 class="header pt-0">
          Next of Kin / Emergency Contact
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="ml-5"
      >
        <v-btn
          color="agency-color-primary"
          :disabled="candidate.is_synced === 1"
          tile
          dark
          small
          outlined
          @click="useCandidateAddress"
        >
          Use Candidate Address
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="candidate.candidate_nok.full_name"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Full Name"
          filled
          :rules="Rules.alphaDashSpace"
        />
        <v-text-field
          v-model="candidate.candidate_nok.phone"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Phone"
          filled
          :rules="Rules.phone"
        />
        <v-text-field
          v-model="candidate.candidate_nok.mobile"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Mobile"
          filled
          :rules="Rules.phone"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          :key="forceUpdateKeys[0]"
          v-model="candidate.candidate_nok.address_one"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Address 1"
          filled
          :rules="Rules.alphaNumericDashSpace"
        />
        <v-text-field
          :key="forceUpdateKeys[1]"
          v-model="candidate.candidate_nok.address_two"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Address 2"
          filled
          :rules="Rules.alphaNumericDashSpace"
        />
        <v-text-field
          :key="forceUpdateKeys[2]"
          v-model="candidate.candidate_nok.address_three"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Address 3"
          filled
          :rules="Rules.alphaNumericDashSpace"
        />
        <v-text-field
          :key="forceUpdateKeys[3]"
          v-model="candidate.candidate_nok.postcode"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Post Code"
          filled
          :rules="Rules.postcode"
          :counter="8"
        />
      </v-col>
    </v-row>
    <v-btn
      tile
      outlined
      color="secondary"
      @click="goBack()"
    >
      Back
    </v-btn>
    <v-btn
      color="agency-color-primary"
      :disabled="!valid"
      tile
      dark
      @click="next()"
    >
      Next
    </v-btn>
  </v-form>
</template>
<script>
export default {
  name: 'NokDetails',
  props: {
    candidate: {
      type: Object,
      default: () => {
        return {
          candidate_details: {},
          candidate_nok: {}
        }
      }
    }
  },
  data: () => ({
    valid: false,
    forceUpdateKeys: [1, 2, 3, 4]
  }),
  methods: {
    useCandidateAddress () {
      this.candidate.candidate_nok.address_one = this.candidate.address_one
      this.candidate.candidate_nok.address_two = this.candidate.address_two
      this.candidate.candidate_nok.address_three = this.candidate.address_three
      this.candidate.candidate_nok.postcode = this.candidate.postcode
      this.forceUpdateKeys = this.forceUpdateKeys.map(function (val) { return ++val })
    },
    next () {
      this.$emit('next', {
        newCandidate: this.candidate
      })
      localStorage.setItem('candidate_register', JSON.stringify(this.candidate))
    },
    goBack () {
      this.$emit('back')
    }
  }
}
</script>
